import LoadingSpinner from '../Modules/LoadingSpinner'

export default function LoadingOverLay () {
    return (
        <div className='loading-overlay-wr'>
            <LoadingSpinner />            
        </div>
    )
}